import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_LOG_LIST = gql`
query getLogs($level: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int) {
  getLogs(level: $level, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType) {
    isAuth
    total
    query
    logs {
      level
      message
      messageMore
      createdAt
      }
    }
  }
`;

const getLogsList = async (variables) => {
  try {
    const result = await client.query({
      query: GET_LOG_LIST,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getLogs: logData } } = result;

    if (logData) {
      return logData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getLogsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getLogsList Error: ${error}`);
    return null;
  }
};

export default getLogsList;
